<div class="loading-overlay w-100 h-100">
  <app-loading-gif-image></app-loading-gif-image>
</div>
